export const createCounter = (start: number = 0) => {
  return () => start++;
};
